<div *ngIf="protestInfo" class="epds_mat_override">
  <mat-card>
    <mat-card-content>
      <div class="indent"></div>
      <table aria-label="Table with Case information" role="presentation" fxFlex>
        <colgroup>
          <col style="width: 140px;">
          <col>
        </colgroup>
        <tbody>
        <tr>
          <td><span><strong>Protester</strong></span></td>
          <td><span>{{ protestInfo.company_Name }}</span></td>
        </tr>
        <tr>
          <td><span><strong>B-Number</strong></span></td>
          <td>
                <span [ngClass]="{ 'pending-entry color_warn': !protestInfo.b_No  }"
                      [matTooltip]="protestInfo.a_No">
                  {{ protestInfo.b_No || "pending" }}
                </span>
          </td>
        </tr>
        <tr>
          <td><span><strong>Agency</strong></span></td>
          <td><span>{{ protestInfo.agency_Name }}</span></td>
        </tr>
        <tr>
          <td><span><strong>Solicitation Number</strong></span></td>
          <td><span>{{ protestInfo.solicitation_No }}</span></td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-content fxLayout="column" fxLayoutAlign="start start" class="no-top-pad no-bottom-pad">
      <div fxFill>
        <div class="indent"></div>
        <div fxFlex>
            <mat-form-field appearance="outline" floatLabel="always" class="doc-select-width">
              <mat-label>Document Type</mat-label>
              <mat-select placeholder="Please Select Type of Document"
                          panelClass="epds-select-override-half"
                          [(value)]="currentDocInfo"
                          (selectionChange)="onDocTypeChange($event)" required>
                <mat-optgroup *ngFor="let group of docGroups" [label]="group">
                  <mat-option *ngFor="let doc of documentsByGroup.get(group)" [value]="doc">
                    {{ doc.doc_Type_Desc }}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
        </div>
      </div>

      @if (selectedDocType != undefined) {
        <div style="min-width: 100%;">
          @if (showGenerateDocTempButton && !(isEditorVisible || isReviewVisible || saving)) {
            <div style="margin-bottom: 20px;">
              <button mat-raised-button color="primary"
                      (click)="onGenerateTemplate()"
                      [disabled]="isEditorVisible || isReviewVisible || saving">
                Generate Template
              </button>
            </div>
          }

          @if (isEditorVisible) {
              <div class="template-editor">
                <ckeditor *ngIf="editorContent" #editor [editor]="ClassicEditor" [config]="CKEditorConfig" [data]="editorContent"></ckeditor>
              </div>
              <mat-card-actions fxLayout="row" fxLayoutAlign="left" fxLayoutGap="16px">
                <button mat-raised-button color="primary"
                        (click)="onEditorSave()"
                        [disabled]="saving">
                  Save
                </button>
                <button mat-raised-button color="warn"
                        (click)="onEditorCancel()"
                        [disabled]="saving">
                  Cancel
                </button>
              </mat-card-actions>
          }

          @if (!isEditorVisible && isReviewVisible && docFileName) {
            <div style="margin-left:auto; margin-right: auto;">
              <mat-card *ngIf="isReviewVisible && docFileName" fxFlex="100" style="margin-bottom: 20px;">
                <mat-card-content fxLayout="row" fxLayoutAlign="left left" >
                  <div class="indent"></div>
                  <div>
                    <a href="javascript:void(0)" (click)="onViewDocument()">{{docFileName}}</a>
                  </div>
                </mat-card-content>

                <mat-card-actions fxLayout="row" fxLayoutAlign="left" fxLayoutGap="16px">
                  <div class="controls">

                    <button mat-raised-button color="accent"
                            (click)="onEditTemplate()"
                            [disabled]="saving">
                      Edit Template
                    </button>
                    <button mat-raised-button color="warn"
                            (click)="onClearEdits()"
                            [disabled]="saving">
                      Clear Edits
                    </button>

                  </div>

                </mat-card-actions>

              </mat-card>
            </div>
          }

        </div>

        <div [hidden]="isEditorVisible" style="width: 100%">

          @if (showGenerateDocTempButton) {
          <div fxLayout="row">
            <div class="indent"></div>
              <div style="font-size: 24px; font-weight: bold; margin-bottom: 20px; display: flex; flex-direction: column; align-items: start;">
                {{ isAnd ? 'AND' : 'OR' }}
              </div>
          </div>
          }

          @if (!isFileUploadNotRequired) {
            <!-- File Upload Component -->
            <mat-form-field floatLabel="always" appearance="outline" style="width: 100%">
              <mat-label> {{ primaryUploadText }} ( {{ uploadDocMessage }} )</mat-label>
              <input matInput style="display: none" />

              <app-file-upload #fileUpload
                               [fileUploadInProgress]="fileUploadInProgress"
                               [wrongFileTypeMessage]="uploadDocMessage"
                               [requiredFileType]="requiredFileType"
                               [primaryUploadText]="primaryUploadText"
                               [associatedDocsOnly]="associatedDocsOnly"
                               (attachAssociatedDocOutput)="onAttachAssociatedDocOutput($event)"
                               (primaryEPDSFileListOutput)="onEPDSFileListChange($event, 'P')"
                               (associateEPDSFileListOutput)="onEPDSFileListChange($event, 'A')">
              </app-file-upload>
            </mat-form-field>
          }


            @if (!isAlwaysVisible && !isFileUploadNotRequired && !isAlwaysProtected) {

              <!-- Document Confidentiality -->
              <mat-form-field floatLabel="always" appearance="outline" style="width: 100%">
                <mat-label>Do any of these documents contain information that is proprietary, confidential, or otherwise not releasable to the public?</mat-label>
                <input matInput style="display: none" required/>

                <mat-radio-group [(ngModel)]="isDocConfidential"
                                 (ngModelChange)="onDocConfidentialChange()"
                                 name="isDocConfidential" required>
                  <mat-radio-button value="Y">Yes</mat-radio-button>
                  <mat-radio-button value="N">No</mat-radio-button>
                </mat-radio-group>
              </mat-form-field>

            }


          <!-- Comments -->
          <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
            <mat-label>Comments</mat-label>
            <textarea matInput [(ngModel)]="comments" name="comments" rows="5" maxlength="250"></textarea>
            <mat-hint>{{ 250 - (comments ? comments.length : 0) }} characters remaining</mat-hint>
          </mat-form-field>

          <mat-card-actions fxLayout="row" fxLayoutAlign="left" fxLayoutGap="16px">
            <button mat-raised-button color="primary"
                    (click)="onSubmit()"
                    [disabled]="saving || !isFormValid">
              <div *appSpinner="saving"></div>
              Submit
            </button>

            <button mat-raised-button color="warn"
                    (click)="onReset()"
                    [disabled]="saving">
              Reset
            </button>
          </mat-card-actions>
        </div>
      }

    </mat-card-content>
  </mat-card>
</div>
